import {Button} from 'antd';
import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';

interface ITaxForecastCommentModalProps {
    value: string;
}
export const TaxForecastCommentModal: FC<ITaxForecastCommentModalProps> = ({
    value: comment,
}: ITaxForecastCommentModalProps) => (
    <>
        {!!comment && (
            <ModalOpenerComponent
                component={(
                    <Button type="default">Посмотреть</Button>
                )}
                modalProps={{
                    title: 'Комментарий ФНС',
                    centered: true,
                }}
                controlLabels={{
                    cancel: 'Закрыть',
                }}
            >
                {comment}
            </ModalOpenerComponent>
        )}
    </>
);
